import {createStore} from "vuex"
import {countryUserModel} from "./country/countryUserModel"
import {countryIsGuestModel} from "./country/countryIsGuestModel"

export default createStore({
  modules: {
    countryUser: countryUserModel,
    countryIsGuest: countryIsGuestModel,
  },
});